<script lang="ts">
  import LL from '$i18n/i18n-svelte';
  import { trimTrailingZero, trimTrailingZeroWithSign } from '$lib/utils/number';
  import { getTranslatedRankTierName, getShortRankTierName } from '.';
  import { isAfter1_0 } from '../season/season';
  import { Division, type RankTier } from './calculation';
  import RankTierImage from './rank-tier-image.svelte';

  export let rankTier: RankTier;
  export let seasonId: number | undefined = undefined;
  export let recordedMMR: number | undefined = undefined;
  export let shortText = false;
  export let hideIcon = false;
</script>

<div class="rp-tier-text">
  {#if !hideIcon}
    <RankTierImage rankTierName={rankTier.tier.tierName} type="circle" />
  {/if}
  <span class="name">
    {#if shortText}
      {getShortRankTierName($LL, rankTier.tier.tierName)}
    {:else}
      {getTranslatedRankTierName($LL, rankTier.tier.tierName)}
    {/if}
    {#if rankTier.division !== Division.None}
      <span>
        {Division[rankTier.division]}
      </span>
    {/if}
  </span>
  <span class="rp">
    {trimTrailingZero(rankTier.lp, 0)}
    {isAfter1_0(seasonId ?? 0) ? 'RP' : 'MMR'}
  </span>
  {#if recordedMMR}
    {@const rpDelta = (rankTier.fullLp ?? 0) - recordedMMR}
    <span class:plus={rpDelta > 0} class:minus={rpDelta < 0}>
      {trimTrailingZeroWithSign(rpDelta, 0)}
    </span>
  {/if}
</div>

<style lang="postcss">
  .rp-tier-text {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-1);
    align-items: center;
  }
</style>
